const stringFilterComparator = (value, filterValue) => {
  if (!value) return false;
  const stringValue = String(value).toLowerCase();
  const compareValue = String(filterValue).toLowerCase();
  return stringValue.indexOf(compareValue) > -1;
};

export { stringFilterComparator };
